namespace $.$$ {
	export class $eve_app_page_components_segmented extends $.$eve_app_page_components_segmented {
	}
}

